export const composerNoticeStyle = {
    width: '100%', minWidth: 0, maxWidth: 'var(--dsh-composer-card-max-width, 100%)',
    marginInline: 'auto', boxSizing: 'border-box',
    fontFamily: 'var(--dsw-font-family, inherit)',
    fontSize: 'var(--dsh-content-font-size-secondary, 13px)', fontWeight: 400,
    lineHeight: 'calc(20px + var(--dsh-content-font-delta-secondary, 0px))',
    color: 'var(--dsw-alias-label-secondary, GrayText)', overflowWrap: 'anywhere',
};
export const composerNoticeSurfaceStyle = {
    ...composerNoticeStyle, padding: '10px 12px',
    borderRadius: 'var(--dsw-radius-md, 8px)',
    background: 'var(--dsw-alias-interactive-bg-hover, transparent)',
};
export const composerNoticeQuietButtonStyle = {
    fontFamily: 'inherit', fontSize: 'inherit', fontWeight: 'inherit', lineHeight: 'inherit',
    color: 'inherit', background: 'transparent', border: 0,
    padding: '6px 10px', cursor: 'pointer', maxWidth: '100%',
};
export const composerNoticeParagraphStyle = {
    marginBlock: 8, maxWidth: '38rem',
};
export const composerNoticeButtonStyle = {
    fontFamily: 'inherit', fontSize: 'inherit', fontWeight: 'inherit', lineHeight: 'inherit',
    color: 'var(--dsw-alias-label-primary, CanvasText)', maxWidth: '100%',
    background: 'transparent', border: '1px solid var(--dsw-alias-border-main, GrayText)',
    borderRadius: 6, padding: '6px 10px', cursor: 'pointer',
};
//# sourceMappingURL=composer-notice-style.js.map